import { render, staticRenderFns } from "./route-list.vue?vue&type=template&id=0993d6d4&"
import script from "./route-list.vue?vue&type=script&lang=js&"
export * from "./route-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports